<script lang="ts">

	/*import { get } from 'svelte/store'

	import {attandance, dataContent,noResults,showDate,counted } from "../store";*/
	import { stationStore } from "../store";
  const { trackList, showPlayer, getSosPageNames} = stationStore; 
  import Tracklist from "./miniPlayerComponents/Tracklist.svelte"
  //import RadioPlayer from "./miniPlayerComponents/RadioPlayer.svelte"
  import OnProgram from "./miniPlayerComponents/OnProgram.svelte"
  import Schedule from "./miniPlayerComponents/RadioPlayerComponents/Schedule.svelte"
  import { fade } from 'svelte/transition';
  import { flip } from 'svelte/animate';

  let showMoreTracks = false

  function toggleShowMoreTracks () : void {
    showMoreTracks = !showMoreTracks
  }


</script>
<div id="radio-top-bar" class="{$showPlayer === false ? 'radio-top-bar--live' : ''} {showMoreTracks === true ? 'show-more-tracks' : ''}">
    
     {#if !$showPlayer}
     <div class="container position-relative" >
      <div class="row">
       <OnProgram></OnProgram>
        {#if $trackList}
       <Tracklist></Tracklist>
       {/if}
      </div>
      <a href="/sos" class="btn-glasbeni-sos font-weight-bold font-size-sm align-items-center"><span class="icon-ear2 mr-2"></span>Glasbeni SOS</a>
      <div class="btn-radio-tracklist-show-more align-items-center justify-content-center"  on:click="{toggleShowMoreTracks}"><span class="icon-arrow2-right"></span></div>
       </div>

     {:else}
   <!-- <RadioPlayer></RadioPlayer> -->
     {/if}
   
  </div>
  {#if $showPlayer}
  <Schedule></Schedule>
  {/if}
